
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 382 248","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.6 1.6C.2 3 0 15.5 0 123.9c0 95 .3 121.1 1.3 122.4 1.1 1.6 13.4 1.7 190.7 1.5l189.5-.3.3-122.4c.1-89.6-.1-122.7-.9-123.7C379.9.2 348.8 0 191.4 0 21.6 0 3 .2 1.6 1.6zm367.8 13.6c.3 1.3.6 50.5.6 109.3 0 95.3-.2 107.3-1.6 109.3l-1.5 2.2H191.5c-96.4 0-176-.3-176.9-.6-1.4-.6-1.6-11.3-1.6-110.8 0-60.7.3-110.6.7-110.9.3-.4 80.4-.7 177.9-.7h177.2l.6 2.2z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M43.7 50.7c-.4.3-.7 33.2-.7 72.9 0 70.5 0 72.4 1.9 73.4 2.8 1.4 24.4 1.3 25.9-.2.9-.9 1.2-13.8 1.2-51.8 0-28.2.4-49.8.9-49 1.8 3.1 9.3 30.6 15.5 56.6 9.3 39.1 10.3 42.7 12.2 44.1 2.5 1.9 26.7 1.8 28.3 0 1.2-1.6 6.2-20.2 15.5-58.2 3.6-14.9 8.1-31.7 10-37.5l3.4-10.5.1 52.5c.1 39.5.4 52.9 1.3 53.8.8.8 5.1 1.2 12.8 1.2 7.7 0 12-.4 12.8-1.2 1.7-1.7 1.7-143.9 0-145.6-.9-.9-7.2-1.2-22-1.2-20.4 0-20.8 0-22.2 2.2-.7 1.3-6 19.8-11.6 41.3-5.7 21.4-11 41.9-12 45.5l-1.7 6.5-1.7-4c-2.7-6.4-8.2-25.5-14.6-51.2-7.1-28.6-9.5-37-11.1-38.9-.9-1.1-5.4-1.4-22.4-1.4-11.6 0-21.5.3-21.8.7zM215.8 50.6c-.5.4-.8 33.2-.8 72.9 0 54.7.3 72.4 1.2 73.3.9.9 10.1 1.2 35.2 1.2 38.3 0 43.3-.6 55.2-6.5 22.7-11.2 36.2-42.8 32.5-76.5-3.2-29.8-13.6-49.4-30.6-57.5-13.1-6.2-18-6.8-57-7.3-19.2-.2-35.3 0-35.7.4zM270.7 77c15.8 1.1 21.4 3.1 27.3 9.7 9.4 10.8 12.3 32.9 7.5 58-2.7 13.9-6.9 20.5-15.9 24.4-4.6 2.1-7 2.3-23.8 2.7-18.2.4-18.6.4-19.8-1.7-1.3-2.6-1.2-89.6.2-92.4 1-2 4.4-2.1 24.5-.7z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M374.702 229.258l-6.84 11.186L7.04 19.79l6.84-11.186z"}})])
          )
        }
      }
    